import { match } from 'path-to-regexp';

export default (template, path, options) => match(template, {
  decode: decodeURIComponent,
  ...options 
})(path).params;